import {Button, Popover} from "antd";
import {SettingOutlined} from "@ant-design/icons";
import type { ReactNode } from "react";

type FilterProps = {
  tableFilter? : ReactNode,
  columnToggle?: ReactNode,
}

function FilterComponent({columnToggle} : FilterProps) {

  return (
      <div className="flex justify-end">
        <Popover
            content={columnToggle}
            title="Select columns"
            trigger="hover"
            placement="bottomRight"
        >
          <Button
              type="text"
              icon={<SettingOutlined/>}
              size="small"
              onClick={(e) => e.stopPropagation()}
          >Settings</Button>
        </Popover>
      </div>
  )
}

export {FilterComponent};